export function StepIndicator({ steps, current }) {
  return (
    <div className="flex items-center mb-6">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            <div className="flex items-center gap-1.5">
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-black flex-shrink-0"
                style={{
                  background: done ? "#dcfce7" : active ? "#4f46e5" : "#f1f5f9",
                  color: done ? "#16a34a" : active ? "#ffffff" : "#94a3b8",
                  border: done ? "1.5px solid #86efac" : active ? "none" : "1.5px solid #e2e8f0",
                  boxShadow: active ? "0 2px 8px rgba(79,70,229,0.3)" : "none",
                }}
              >
                {done ? "✓" : i + 1}
              </div>
              <span
                className="text-[10px] font-bold whitespace-nowrap"
                style={{ color: active ? "#4f46e5" : done ? "#16a34a" : "#94a3b8" }}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className="flex-1 h-0.5 mx-2 rounded-full"
                style={{ background: done ? "#86efac" : "#e2e8f0" }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
